<template>
    <b-dropdown right :text="$t('simple.actions')" size="sm">

        <template v-if="cell.item.status != 2">
            <template>
                <template v-if="cell.item.integration === 'facebook'">
                    <b-dropdown-item class="bg-facebook-login"
                        @click="$emit('connect', cell.item.id, cell.item.integration_id, cell.item.username)"><font-awesome-icon
                            :icon="['fab', data.value.icon]" />{{ $t('simple.login_with_fb') }}</b-dropdown-item>
                </template>
                <template v-else>
                    <b-dropdown-item
                        v-if="cell.item.integration_id !== 'googleplay' && cell.item.integration_id !== 'twitter'"
                        @click="$emit('connect', cell.item.id, cell.item.integration_id, cell.item.username)">
                        <font-awesome-icon :icon="['fas', 'link']" /> {{ $t('simple.connect') }}
                    </b-dropdown-item>
                </template>

            </template>


            <b-dropdown-item @click="$emit('twitterConnect', cell.item.id)"
                v-if="cell.item.integration.id === 'twitter'">
                <font-awesome-icon :icon="['fas', 'link']" /> {{ $t('simple.connect') }}
            </b-dropdown-item>

            <b-dropdown-item @click="$emit('jsonModal', cell.item.id, cell.item.username)"
                v-if="cell.item.integration.id === 'googleplay'">{{ $t('page.upload_file') }}
            </b-dropdown-item>

            <b-dropdown-item :class="!user_permissions.includes('update-accounts') ? 'cursor-not-allowed' : ''"
                             v-b-tooltip.hover.right="{ title: !user_permissions.includes('update-accounts') ? $t('permission.permission_denied', { permission: 'update-accounts' }) : '', customClass: 'tooltip-dark' }"
                             :disabled="!user_permissions.includes('update-accounts')" @click="$emit('edit', cell.item.id)">
                <font-awesome-icon :icon="['far', 'edit']" /> {{ $t('simple.edit') }}
            </b-dropdown-item>

            <b-dropdown-item v-if="cell.item.integration.id === 'whatsapp'"
                             :class="!user_permissions.includes('update-accounts') ? 'cursor-not-allowed' : ''"
                             v-b-tooltip.hover.right="{ title: !user_permissions.includes('update-accounts') ? $t('permission.permission_denied', { permission: 'update-accounts' }) : '', customClass: 'tooltip-dark' }"
                             :disabled="!user_permissions.includes('update-accounts')"
                @click="$emit('whatsappProfileEdit', cell.item.id)">
                <font-awesome-icon :icon="['far', 'edit']" /> {{ $t('simple.edit_whatsapp_profile') }}
            </b-dropdown-item>

            <b-dropdown-item variant="warning"
                             :class="!user_permissions.includes('update-accounts') ? 'cursor-not-allowed' : ''"
                             v-b-tooltip.hover.left="{ title: !user_permissions.includes('update-accounts') ? $t('permission.permission_denied', { permission: 'update-accounts' }) : '', customClass: 'tooltip-dark' }"
                             :disabled="!user_permissions.includes('update-accounts')"
                             @click="$emit('deactivate', cell.item)">
                <font-awesome-icon :icon="['fas', 'ban']" /> {{ $t('simple.deactivate') }}
            </b-dropdown-item>

            <b-dropdown-item variant="danger"
                             :class="!user_permissions.includes('delete-accounts') ? 'cursor-not-allowed' : ''"
                             v-b-tooltip.hover.right="{ title: !user_permissions.includes('delete-accounts') ? $t('permission.permission_denied', { permission: 'delete-accounts' }) : '', customClass: 'tooltip-dark' }"
                             :disabled="!user_permissions.includes('delete-accounts')" @click="$emit('remove', cell.item.id)">
                <font-awesome-icon :icon="['fas', 'trash-alt']" /> {{ $t('simple.delete') }}
            </b-dropdown-item>

        </template>
        <template v-else>
            <b-dropdown-item variant="success"
                             :class="!user_permissions.includes('update-accounts') ? 'cursor-not-allowed' : ''"
                             v-b-tooltip.hover.right="{ title: !user_permissions.includes('update-accounts') ? $t('permission.permission_denied', { permission: 'update-accounts' }) : '', customClass: 'tooltip-dark' }"
                             :disabled="!user_permissions.includes('update-accounts')"
                             @click="$emit('activate', cell.item.id)">
                <font-awesome-icon :icon="['far', 'check-circle']" /> {{ $t('simple.activate') }}
            </b-dropdown-item>

            <b-dropdown-item variant="danger"
                             :class="!user_permissions.includes('delete-accounts') ? 'cursor-not-allowed' : ''"
                             v-b-tooltip.hover.right="{ title: !user_permissions.includes('delete-accounts') ? $t('permission.permission_denied', { permission: 'delete-accounts' }) : '', customClass: 'tooltip-dark' }"
                             :disabled="!user_permissions.includes('delete-accounts')" @click="$emit('remove', cell.item.id)">
                <font-awesome-icon :icon="['fas', 'trash-alt']" /> {{ $t('simple.delete') }}
            </b-dropdown-item>
        </template>

    </b-dropdown>

</template>

<script>

import {mapGetters} from "vuex";
export default {

    props: ['cell'],

    data() {
        return {
        }
    },

    methods: {
    },
  computed: {
    ...mapGetters({
      user_permissions: 'User/getUserPermissions',
    })
  },

}

</script>
